import { useEffect } from 'react';
import { motion } from 'framer-motion';

import preloaderVideo from '../../assests/preloader.webm';

export default function Preloader({ onComplete }: { onComplete: () => void }) {
  useEffect(() => {
    const exitTimer = setTimeout(() => {
      onComplete();
    }, 3000);

    return () => clearTimeout(exitTimer);
  }, [onComplete]);

  return (
    <motion.div
      initial={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
      exit={{
        opacity: 0,
        scale: 1.04,
        filter: 'blur(8px)',
      }}
      transition={{ duration: 0.9, ease: [0.4, 0, 0.2, 1] }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black"
    >
      {/* Crop container — hides the bottom ~23% where the watermark is */}
      <motion.div
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
        style={{
          width: '280px',
          height: '215px',
          overflow: 'hidden',
          position: 'relative',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
        }}
      >
        <video
          src={preloaderVideo}
          autoPlay
          muted
          loop
          playsInline
          style={{
            width: '280px',
            height: '280px',
            objectFit: 'cover',
            objectPosition: 'top',
          }}
        />
      </motion.div>
    </motion.div>
  );
}
